/** Use for img src and CSS url(). Paths may contain spaces (TTC folders). */
export function publicSrc(path) {
  const base = process.env.PUBLIC_URL || '';
  return `${base}${encodeURI(path)}`;
}

const ORILLIA_OVERVIEW =
  'Advanced Metal Shop supplied the Orillia Recreation Centre metal scope from tender through fabrication and installation, including interior and exterior handrails, stair guards, and fencing per contract documents. Structural or embedded steel was installed during rough-in where specified; photographs focus on completed, exposed guard and railing assemblies.\n\nWork was coordinated with the construction schedule and other trades so railings and guards were ready for inspection as areas turned over. Finishes emphasize durable black steel aligned with the facility circulation and exterior walkway design.';

const DUNDAS_WEST_OVERVIEW =
  'Dundas West Station (TTC Line 2, Bloor-Danforth): miscellaneous metals and structural steel from tender through fabrication and installation to TTC and consultant drawings. Images show mainly exposed platform and finish-adjacent work; structural steel in walls, ceilings, or fire-rated assemblies is often concealed after completion.\n\nFabricated items were built and tagged in our shop for sequenced delivery and install during TTC-approved access windows. Field installation followed approved details for platform-edge hardware, posts, rails, and related assemblies coordinated with finishes and safety strip work.';

const ROYAL_YORK_OVERVIEW =
  'Royal York Station (TTC Line 2, Bloor-Danforth): miscellaneous metals and structural steel from tender through fabrication and installation. Gallery images document installed field work; structural members may be covered by finishes, fireproofing, or architectural buildup at turnover.\n\nDeliveries and lifts were staged with TTC site staff while the line remained in service. Bolt-up, welding, and torque requirements were completed and reviewed per the contract quality plan before adjacent finishes closed in.';

const DUFFERIN_OVERVIEW =
  'Dufferin Station (TTC Line 2, Bloor-Danforth): miscellaneous metals and structural steel from tender through fabrication and installation, coordinated with platform wall, tile, and advertising interfaces per the drawing set. On this contract, structural work centered on selective column or channel replacements as detailed, together with platform-edge rails, posts, clips, and supports. Photos emphasize visible rail, post, and trim work; other structural items may not appear in finished views.\n\nShop fabrication focused on accurate fit so field crews could set clips, angles, supports, and the specified replacement members without rework at the platform envelope. Overnight installation was aligned with track clearance, fire, and operational rules for the live subway environment.';

const CHRISTIE_OVERVIEW =
  'Christie Station (TTC Line 2, Bloor-Danforth): miscellaneous metals and structural steel from tender through fabrication and installation, including stairs, elevator areas, guards, and platform-related items. The brick-clad station extension visible at grade is included in this scope: Advanced Metal Shop supplied and installed the structural steel for that extension. Images highlight exposed stainless and circulation metal on the concourse and platform; structural work within the brick envelope and behind other finishes may not read clearly in photographs.\n\nStainless rails and guards were fabricated and finished for transit use, with weld and surface quality held to project standards. Elevator, stair, and concourse work was sequenced with the general contractor to reduce conflicts during peak passenger periods.';

const KING_OVERVIEW =
  'King Station (TTC Line 1, Yonge-University): miscellaneous metals and structural steel from tender through fabrication and installation under tunnel and platform constraints. Documentation includes tunnel and platform areas; structural steel may be hidden behind completed finishes and services.\n\nHoisting and staging respected tight headroom, track clearance, and fire separation requirements typical of a downtown Line 1 cavern station. Anchors, connections, and inspections were completed to TTC hold points before finishes and MEP covers concealed the structural package where applicable.';

const QUEENS_PARK_OVERVIEW =
  'Queen\'s Park Station (TTC Line 1, Yonge-University): miscellaneous metals and structural steel from tender through fabrication and installation, coordinated with curved tunnel wall construction. Images include construction and finished conditions; structural backup may be concealed behind architectural panels at completion.\n\nAssemblies were sized and tagged for shaft and platform delivery so lifts and rigging matched the available work blocks. Curved backup and track-adjacent steel was set and surveyed before architectural panels and banding closed out the wall line.';

const SPADINA_OVERVIEW =
  'Spadina Station (TTC Line 1, Yonge-University): miscellaneous metals and structural steel from tender through fabrication and installation, with prefabrication used where the drawings and site logistics allowed. Gallery images show representative visible metal and selected install stages; structural elements above ceilings or in cavities may not be pictured after turnover.\n\nPrefabricated modules reduced cutting and fit-up time in congested concourse and platform zones near interchange traffic. Welding and hot work were carried out under TTC site rules, with coordination for fire watch and access alongside other trades.';

const ST_PATRICK_OVERVIEW =
  'St. Patrick Station (TTC Line 1, Yonge-University): miscellaneous metals and structural steel for tunnel and concourse rehabilitation, from tender through fabrication and installation. Progress photographs reflect phased work; structural steel is frequently covered before the station is returned to public use.\n\nScope spanned rough tunnel framing through door bucks, wall support, and platform-adjacent miscellaneous metal per the engineer\'s issued drawings. Each phase was closed out for inspection before finishes, fireproofing, and services hid prior structural work.';

/** @typedef {{ id: string, title: string, mainImage: string, heroImage: string, description: string, overview: string, gallery: string[] }} PortfolioProject */

/** @type {PortfolioProject[]} */
export const portfolioProjects = [
  {
    id: 'orillia',
    title: 'Orillia Recreation Centre',
    mainImage: '/Orillia/orilliaMain.jpg',
    heroImage: '/Orillia/orilliaMain.jpg',
    description:
      'Railings, stair guards, and exterior fencing.',
    overview: ORILLIA_OVERVIEW,
    gallery: [
      '/Orillia/IMG_0756.jpg',
      '/Orillia/IMG_0758.jpg',
      '/Orillia/IMG_0759.jpg',
      '/Orillia/IMG_0760.jpg',
      '/Orillia/IMG_0764.jpg',
      '/Orillia/IMG_0765.jpg',
      '/Orillia/IMG_0768.jpg',
      '/Orillia/IMG_0770.jpg',
    ],
  },
  {
    id: 'dundas-west',
    title: 'TTC Dundas West Station',
    mainImage: '/TTC Dundas West/IMG_2680.JPG',
    heroImage: '/TTC Dundas West/IMG_2680.JPG',
    description:
      'Line 2 Bloor-Danforth. Platform and concourse metalwork.',
    overview: DUNDAS_WEST_OVERVIEW,
    gallery: [
      '/TTC Dundas West/IMG_2605.jpg',
      '/TTC Dundas West/IMG_2606.jpg',
      '/TTC Dundas West/IMG_2607.jpg',
      '/TTC Dundas West/IMG_2608.jpg',
      '/TTC Dundas West/IMG_2609.jpg',
      '/TTC Dundas West/IMG_2610.jpg',
      '/TTC Dundas West/IMG_2611.jpg',
      '/TTC Dundas West/IMG_2612.jpg',
    ],
  },
  {
    id: 'royal-york',
    title: 'TTC Royal York Station',
    mainImage: '/TTC Royal York/IMG_2679.JPG',
    heroImage: '/TTC Royal York/IMG_2679.JPG',
    description:
      'Line 2 Bloor-Danforth. Tunnel, concourse, and platform scope.',
    overview: ROYAL_YORK_OVERVIEW,
    gallery: [
      '/TTC Royal York/IMG_2598.jpg',
      '/TTC Royal York/IMG_2599.jpg',
      '/TTC Royal York/IMG_2600.jpg',
      '/TTC Royal York/IMG_2601.jpg',
      '/TTC Royal York/IMG_2602.jpg',
      '/TTC Royal York/IMG_2603.jpg',
      '/TTC Royal York/IMG_2604.jpg',
    ],
  },
  {
    id: 'dufferin',
    title: 'TTC Dufferin Station',
    mainImage: '/TTC Dufferin/IMG_2613.jpg',
    heroImage: '/TTC Dufferin/IMG_2613.jpg',
    description:
      'Line 2 Bloor-Danforth. Selective column or channel replacement; platform wall, edge, and finish interfaces.',
    overview: DUFFERIN_OVERVIEW,
    gallery: [
      '/TTC Dufferin/IMG_2614.jpg',
      '/TTC Dufferin/IMG_2615.jpg',
      '/TTC Dufferin/IMG_2616.jpg',
      '/TTC Dufferin/IMG_2617.jpg',
      '/TTC Dufferin/IMG_2618.jpg',
      '/TTC Dufferin/IMG_2619.jpg',
      '/TTC Dufferin/IMG_2620.jpg',
      '/TTC Dufferin/IMG_2621.jpg',
      '/TTC Dufferin/IMG_2622.jpg',
      '/TTC Dufferin/IMG_2623.jpg',
      '/TTC Dufferin/IMG_2624.jpg',
      '/TTC Dufferin/IMG_2625.jpg',
      '/TTC Dufferin/IMG_2626.jpg',
    ],
  },
  {
    id: 'christie',
    title: 'TTC Christie Station',
    mainImage: '/TTC Christie/IMG_2638.jpg',
    heroImage: '/TTC Christie/IMG_2638.jpg',
    description:
      'Line 2. Full structural steel for the brick-clad extension; stairs, elevators, and platform metal.',
    overview: CHRISTIE_OVERVIEW,
    gallery: [
      '/TTC Christie/IMG_2627.jpg',
      '/TTC Christie/IMG_2628.jpg',
      '/TTC Christie/IMG_2629.jpg',
      '/TTC Christie/IMG_2630.jpg',
      '/TTC Christie/IMG_2631.jpg',
      '/TTC Christie/IMG_2632.jpg',
      '/TTC Christie/IMG_2633.jpg',
      '/TTC Christie/IMG_2634.jpg',
      '/TTC Christie/IMG_2635.jpg',
      '/TTC Christie/IMG_2636.jpg',
      '/TTC Christie/IMG_2637.jpg',
    ],
  },
  {
    id: 'king',
    title: 'TTC King Station',
    mainImage: '/TTC King/IMG_2664.jpg',
    heroImage: '/TTC King/IMG_2664.jpg',
    description:
      'Line 1 Yonge-University. Tunnel and platform work.',
    overview: KING_OVERVIEW,
    gallery: [
      '/TTC King/IMG_2665.jpg',
      '/TTC King/IMG_2666.jpg',
      '/TTC King/IMG_2667.jpg',
      '/TTC King/IMG_2668.jpg',
      '/TTC King/IMG_2669.jpg',
      '/TTC King/IMG_2670.jpg',
      '/TTC King/IMG_2671.jpg',
      '/TTC King/IMG_2672.jpg',
    ],
  },
  {
    id: 'queens-park',
    title: "TTC Queen's Park Station",
    mainImage: '/TTC Queens Park/IMG_2652.jpg',
    heroImage: '/TTC Queens Park/IMG_2652.jpg',
    description:
      'Line 1 Yonge-University. Curved tunnel wall and track-adjacent steel.',
    overview: QUEENS_PARK_OVERVIEW,
    gallery: [
      '/TTC Queens Park/IMG_2648.jpg',
      '/TTC Queens Park/IMG_2649.jpg',
      '/TTC Queens Park/IMG_2650.jpg',
      '/TTC Queens Park/IMG_2651.jpg',
      '/TTC Queens Park/IMG_2653.jpg',
    ],
  },
  {
    id: 'spadina',
    title: 'TTC Spadina Station',
    mainImage: '/TTC Spadina/IMG_2639.jpg',
    heroImage: '/TTC Spadina/IMG_2639.jpg',
    description:
      'Line 1 Yonge-University. Interchange concourse, stairs, and platform.',
    overview: SPADINA_OVERVIEW,
    gallery: [
      '/TTC Spadina/IMG_2640.jpg',
      '/TTC Spadina/IMG_2641.jpg',
      '/TTC Spadina/IMG_2642.jpg',
      '/TTC Spadina/IMG_2643.jpg',
      '/TTC Spadina/IMG_2644.jpg',
      '/TTC Spadina/IMG_2645.jpg',
      '/TTC Spadina/IMG_2646.jpg',
      '/TTC Spadina/IMG_2647.jpg',
    ],
  },
  {
    id: 'st-patrick',
    title: 'TTC St. Patrick Station',
    mainImage: '/TTC St Patrick/IMG_2663.jpg',
    heroImage: '/TTC St Patrick/IMG_2663.jpg',
    description:
      'Line 1 Yonge-University. Tunnel and concourse rehabilitation.',
    overview: ST_PATRICK_OVERVIEW,
    gallery: [
      '/TTC St Patrick/IMG_2654.jpg',
      '/TTC St Patrick/IMG_2655.jpg',
      '/TTC St Patrick/IMG_2656.jpg',
      '/TTC St Patrick/IMG_2657.jpg',
      '/TTC St Patrick/IMG_2658.jpg',
      '/TTC St Patrick/IMG_2659.jpg',
      '/TTC St Patrick/IMG_2660.jpg',
      '/TTC St Patrick/IMG_2661.jpg',
    ],
  },
];

export function getProjectById(id) {
  return portfolioProjects.find((p) => p.id === id);
}
